<template>
  <div id="banner-list">
    <div class="banner" v-for="(banner, index) in bannerList"
                        :key="index">
      <a v-bind:href="banner.ta_url" target="_blank">
        <img :src="banner.ta_pic" />
      </a>
    </div>
    <div v-if="!bannerList.length" class="banner-null">
      <div class="img-null">
        <img src="../../assets/img/speaker.svg" />
      </div>
      <h2 class="title">優惠活動即將上線!</h2>
      <div class="sub-title">敬請您期待，我們的優惠活動即將上線！</div>
    </div>
    <div class="back">
      <v-btn class="v-btn-primary" color="primary" outlined @click="back">
        返回
      </v-btn>
    </div>
  </div>
</template>
<script>
export default {
  name: 'BannerList',
  components: {},
  data() {
    return {
      bannerList: [],
    }
  },
  created() {
    if (this.$route.params.list) {
      this.bannerList.push(...this.$route.params.list)
    } else if (localStorage.getItem('homepage')) {
      const banner = JSON.parse(localStorage.getItem('homepage')).data.data
        .regularBannerBlock
      if (banner) this.bannerList.push(...banner)
    }
  },
  methods: {
    toCuration(link) {
      this.$router.push({ name: 'curation', params: { id: link } })
    },
    back() {
      this.$router.replace({ name: 'homepage' })
    },
  },
}
</script>

<style lang="scss" scoped>
#banner-list {
  height: 100%;
  padding: 20px 4.8%;
  .banner {
    min-height: 150px;
    border-radius: 16px;
    overflow: hidden;
    font-size: 0;
    margin-top: 20px;
    background-color: #f3f5f8;
    img {
      width: 100%;
      &.error-img {
        display: none;
        & + .error-holder {
          display: block;
        }
      }
    }
    .error-holder {
      display: none;
    }
  }
  .banner-null {
    height: 85%;
    padding-top: 14%;
    text-align: center;
    .img-null {
      width: 30.7%;
      margin: auto;
    }
    .title {
      margin-top: 24px;
      font-size: 18px;
      font-weight: 600;
      letter-spacing: 0.56px;
      color: #383838;
    }
    .sub-title {
      margin-top: 8px;
      font-size: 14px;
      font-weight: 500;
      color: #545454;
    }
  }
  .back {
    margin-top: 20px;
  }
}
</style>
